import React from 'react';
import { HintButton } from '../../common/HintButton';

export const CardHint = ({ hint }) => (
  <HintButton id="studyDeck" hint={hint} emptyLabel="No hint available for this card" />
);
